import script from "./UsuarioProximasReservasDetalle.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioProximasReservasDetalle.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioProximasReservasDetalle.vue?vue&type=style&index=0&id=598e629c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-598e629c"]])

export default __exports__